import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/PasswordGate.css';

const PasswordGate = ({ onCorrectPassword }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  // The actual password - obscured but not impossible to find if someone really digs
  const correctPassword = 'komok2025';

  const handleSubmit = (e) => {
    e.preventDefault();

    if (password.toLowerCase() === correctPassword) {
      // Store in sessionStorage so they don't have to re-enter during session
      sessionStorage.setItem('partyAccess', 'granted');
      onCorrectPassword();
    } else {
      setError(true);
      setPassword('');
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <div className="password-gate">
      <div className="password-container">
        <div className="dead-cat">
          <pre className="ascii-art">{`
    /\\_/\\
   ( o.o )
    > ^ <
   /|   |\\
  (_|   |_)
      `}</pre>
          <div className="rip-stone">
            <div className="rip-text">R.I.P</div>
            <div className="rip-subtext">Curiosity</div>
          </div>
        </div>

        <h1 className="warning-text">Curiosity killed the cat</h1>

        <p className="hint-text">
          This page is password protected.
        </p>

        <form onSubmit={handleSubmit} className="password-form">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password..."
            className={`password-input ${error ? 'error' : ''}`}
            autoFocus
          />
          <button type="submit" className="submit-btn">
            ENTER
          </button>
        </form>

        {error && (
          <div className="error-message">
            ✗ Incorrect password
          </div>
        )}

        <Link to="/" className="back-to-invite-link">
          ← Go back to the invite
        </Link>

        <div className="mystery-hint">
          <div style={{
            position: 'relative',
            padding: '56.25% 0 0 0',
            maxWidth: '500px',
            width: '100%',
            border: '2px solid #444',
            borderRadius: '8px',
            overflow: 'hidden'
          }}>
            <iframe
              src="https://player.vimeo.com/video/1065367766?h=d3a6894c79&badge=0&autopause=0&player_id=0&app_id=58479"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="Hype Video 1"
            />
          </div>

         

          <span className="hint-whisper">Looks like you still want hype, here's a second video...</span>
        </div>
      </div>
    </div>
  );
};

export default PasswordGate;
